(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
      this.boundDeferredStylesheetLoad = this.handleDeferredStylesheetLoad.bind(this);
      this.boundWindowLoadRefresh = this.scheduleHeaderMetricsRefresh.bind(this);
      this.viewportMatchMedia = window.matchMedia('(max-width: 990px)');

      this.setHeaderHeight();

      if (typeof this.viewportMatchMedia.addEventListener === 'function') {
        this.viewportMatchMedia.addEventListener('change', this.boundSetHeaderHeight);
        this.viewportMatchMediaMode = 'event';
      } else if (typeof this.viewportMatchMedia.addListener === 'function') {
        this.viewportMatchMedia.addListener(this.boundSetHeaderHeight);
        this.viewportMatchMediaMode = 'listener';
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('wald:deferred-stylesheet-loaded', this.boundDeferredStylesheetLoad);

      if (document.readyState === 'complete') {
        this.scheduleHeaderMetricsRefresh();
      } else {
        window.addEventListener('load', this.boundWindowLoadRefresh, { once: true });
      }

      if (document.fonts?.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(() => {
          if (!this.isConnected) return;
          this.scheduleHeaderMetricsRefresh();
        });
      }

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    refreshHeaderMetrics() {
      this.setHeaderHeight();
      this.createObserver();
    }

    scheduleHeaderMetricsRefresh() {
      if (!this.header) return;

      if (this.headerMetricsRefreshFrame) {
        window.cancelAnimationFrame(this.headerMetricsRefreshFrame);
      }

      if (this.headerMetricsRefreshFrameFollowUp) {
        window.cancelAnimationFrame(this.headerMetricsRefreshFrameFollowUp);
      }

      this.headerMetricsRefreshFrame = window.requestAnimationFrame(() => {
        this.headerMetricsRefreshFrame = undefined;
        this.headerMetricsRefreshFrameFollowUp = window.requestAnimationFrame(() => {
          this.headerMetricsRefreshFrameFollowUp = undefined;
          if (!this.isConnected) return;
          this.refreshHeaderMetrics();
        });
      });
    }

    handleDeferredStylesheetLoad(event) {
      const href = event.detail?.href || '';
      if (!href) return;

      if (
        href.indexOf('base.css') === -1 &&
        href.indexOf('wald-header.css') === -1 &&
        href.indexOf('wald-fonts.css') === -1 &&
        href.indexOf('component-localization-form.css') === -1
      ) {
        return;
      }

      this.scheduleHeaderMetricsRefresh();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('wald:deferred-stylesheet-loaded', this.boundDeferredStylesheetLoad);
      window.removeEventListener('load', this.boundWindowLoadRefresh);

      if (this.viewportMatchMedia) {
        if (this.viewportMatchMediaMode === 'event') {
          this.viewportMatchMedia.removeEventListener('change', this.boundSetHeaderHeight);
        } else if (this.viewportMatchMediaMode === 'listener') {
          this.viewportMatchMedia.removeListener(this.boundSetHeaderHeight);
        }
      }

      if (this.headerMetricsRefreshFrame) {
        window.cancelAnimationFrame(this.headerMetricsRefreshFrame);
      }

      if (this.headerMetricsRefreshFrameFollowUp) {
        window.cancelAnimationFrame(this.headerMetricsRefreshFrameFollowUp);
      }

      this.headerObserver?.disconnect();
      this.headerObserver = undefined;
    }

    createObserver() {
      if (!this.header) return;

      this.headerObserver?.disconnect();
      this.headerObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.headerObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const HeaderDrawerElement = customElements.get('header-drawer');

  if (HeaderDrawerElement && !HeaderDrawerElement.prototype.getHeaderBoundsElement) {
    HeaderDrawerElement.prototype.getHeaderBoundsElement = function () {
      return this.closest('.header-wrapper')?.querySelector('.header') || this.closest('.header-wrapper') || this.header;
    };

    HeaderDrawerElement.prototype.updateHeaderBottomPosition = function () {
      this.header = this.header || document.querySelector('.section-header');
      this.headerBoundsElement = this.getHeaderBoundsElement();
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.headerBoundsElement.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    };

    HeaderDrawerElement.prototype.openMenuDrawer = function (summaryElement) {
      this.ensureDrawerContent?.();
      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset =
        this.borderOffset || (this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0);
      this.onResize = () => {
        this.updateHeaderBottomPosition();
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      };
      this.updateHeaderBottomPosition();
      this.header.classList.add('menu-open');

      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });

      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    };
  }


  } catch(e) { console.error(e); }
})();
})();
